import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';
import { ReactNode } from 'react';
import Icon from '../Icon/index.js';

export interface NotificationBannerProps {
  children: ReactNode;
  onDismiss?: () => void;
}

export default function NotificationBanner({
  children,
  onDismiss,
}: NotificationBannerProps): JSX.Element {
  const partner = usePartner();
  return (
    <div
      className={cx({
        'w-full p-4 flex items-center justify-center': true,
        [BackgroundColors[Color.Brand]]: partner?.whitelabeling?.brandColor,
        [BackgroundColors[Color.Primary]]: !partner?.whitelabeling?.brandColor,
      })}
    >
      {children}
      {onDismiss && (
        <div className="absolute z-10 right-2">
          <button type="button" className="cursor-pointer" onClick={onDismiss}>
            <Icon type="close" size="LG" responsiveSize="ResponsiveMD" color={Color.White} />
          </button>
        </div>
      )}
    </div>
  );
}
